import { environment } from '@environment';

// This is temporary, we should add frontend base url to .env
export const FRONT_END_BASE_URL = environment.apiUrl.replace('api.', '');
